/* src/app/order/components/standard-selection/standard-selection.style.scss */
h4 {
  font-family: Arial, sans-serif;
  font-size: 26px;
  font-weight: bold;
  line-height: 1.23;
  letter-spacing: normal;
  color: #007d40;
  margin-top: 50px;
  margin-bottom: 0;
}
h5 {
  font-family: Arial, sans-serif;
  font-size: 13px;
  font-weight: bold;
  line-height: 1.85;
  color: #585858;
  margin-top: 5px;
  margin-bottom: 20px;
}
.standard-selection-buttons-wrapper .standard-selection-buttons {
  display: flex;
  flex-wrap: wrap;
}
.standard-selection-buttons-wrapper .standard-selection-buttons .break {
  display: none;
}
.standard-selection-buttons-wrapper .standard-selection-buttons standard-button {
  margin-right: 20px;
  margin-bottom: 20px;
}
@media screen and (max-width: 600px) {
  .break {
    display: block;
    height: 0;
  }
}
/*# sourceMappingURL=standard-selection.style.css.map */
